import React, { useRef, useEffect } from "react";
import Trix from "trix";
import "trix/dist/trix.css";
import PropTypes from "prop-types";
import { useField } from "formik";

addEventListener("trix-before-initialize", () => {
  Trix.config.blockAttributes.heading1 = {
    tagName: "h3",
    terminal: true,
    breakOnReturn: true,
  };
});

export default function TextEditor(props) {
  const [field, , helpers] = useField(props);
  const { placeholder } = props;
  const trixInput = useRef(null);

  useEffect(() => {
    const unusedClasses = [
      ".trix-button--icon-increase-nesting-level",
      ".trix-button--icon-decrease-nesting-level",
      ".trix-button--icon-quote",
      ".trix-button--icon-code",
      ".trix-button--icon-attach",
      ".trix-button--icon-link",
      ".trix-button-group--file-tools",
    ];
    const handleInitialize = () => {
      unusedClasses.forEach((cls) => {
        const element = document.querySelector(cls);
        if (element) element.remove();
      });
    };

    const currentTrix = trixInput.current;

    if (currentTrix) {
      const handleChange = () => {
        helpers.setValue(currentTrix.value);
      };

      const handleBlur = () => {
        helpers.setTouched(true);
      };

      currentTrix.addEventListener("trix-initialize", handleInitialize);
      currentTrix.addEventListener("trix-change", handleChange);
      currentTrix.addEventListener("trix-blur", handleBlur);

      return () => {
        if (currentTrix) {
          currentTrix.removeEventListener("trix-initialize", handleInitialize);
          currentTrix.removeEventListener("trix-change", handleChange);
          currentTrix.removeEventListener("trix-blur", handleBlur);
        }
      };
    }
  }, [helpers]);

  useEffect(() => {
    if (trixInput?.current?.editor) {
      const currentHTML = trixInput.current.value;
      if (field.value !== currentHTML) {
        trixInput.current.editor.loadHTML(field.value || "");
      }
    }
  }, [field.value]);

  return (
    <div>
      <input type="hidden" id={props.name} value={field.value || ""} name={props.name} />
      <trix-editor
        input={props.name}
        ref={trixInput}
        className="trix-editor"
        data-testid="trix-editor"
        placeholder={
          placeholder || "Texto sobre ubicación, amenidades, cosas que hay alrededor, etc."
        }
      ></trix-editor>
    </div>
  );
}

TextEditor.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};
